import dialogPolyfill from 'dialog-polyfill';

// @ts-ignore
let $ = window.jQuery;

const usePolyfill = typeof HTMLDialogElement !== 'function';


// Register any existing modals on the page.
$(function () {
    if (usePolyfill) {
        document.body.classList.add('no-dialog-support');
    }

    $('dialog').each(function () {
        registerDialogPolyfill(this as HTMLDialogElement);
    });

    if (usePolyfill) {
        // Make sure the custom dialog close button works when using the polyfill
        $('body').on('submit', '.frDialog-close', function (e) {
            e.preventDefault();
            $(this).closest('dialog').get(0).close();
        })
    }
});

export function registerDialogPolyfill(element: HTMLDialogElement): void {
    if (usePolyfill) {
        dialogPolyfill.registerDialog(element);
    }
}

interface DialogOptions {
    title: string;
    content: string | HTMLElement;
    footer: string | HTMLElement;
    /**
     * Only close via API.
     */
    blockUI: boolean;

    cssClass: string;
}

function mergeOptions(options: DialogOptions): DialogOptions {
    const defaults: DialogOptions = {
        title: '',
        content: '',
        footer: '',
        cssClass: '',
        blockUI: false
    };
    return $.extend({}, defaults, options);
}

function header(options: DialogOptions) {
    const header = $('<header>');
    header.addClass('frDialog-header');
    if (options.title) {
        header.append('<h2>' + options.title + '</h2>');
    }

    if (!options.blockUI) {
        header.append(`<form method="dialog" class="frDialog-close"><button value="close" title="${FestivalI18n.close_dialog}">×</button></form>`);
    }
    return header;
}

function footer(options: DialogOptions) {
    const footer = $('<footer>');
    footer.addClass('frDialog-footer');
    footer.append(options.footer);
    return footer;
}

function updateContent(this: JQuery<HTMLDialogElement>, content: string | HTMLElement) {
    this.find('.frDialog-content').html(content);
    return this;
}

function updateTitle(this: JQuery<HTMLDialogElement>, title: string) {
    this.find('.frDialog-header h2').html(title);
    return this;
}

interface DialogInstance {
    $el: JQuery<HTMLDialogElement>;
    show: () => void;
    close: () => void;
    remove: () => void;
    content: (content: string | HTMLElement) => JQuery<HTMLDialogElement>;
    title: (content: string | HTMLElement) => JQuery<HTMLDialogElement>;
}

export default function dialog(options: DialogOptions): DialogInstance {
    options = mergeOptions(options);
    const dialog: JQuery<HTMLDialogElement> = $('<dialog>');
    dialog.addClass('frDialog');
    if (options.cssClass.length > 0) {
        dialog.addClass(options.cssClass);
    }
    dialog.append(header(options));
    dialog.append(`<div class="frDialog-content">${options.content}</div>`);
    dialog.append(footer(options));

    // Support older browsers
    registerDialogPolyfill(dialog[0]);

    const instance: DialogInstance = {
        $el: dialog,
        show: dialog[0].showModal.bind(dialog[0]),
        close: dialog[0].close.bind(dialog[0]),
        remove: dialog.remove.bind(dialog),
        content: updateContent.bind(dialog),
        title: updateTitle.bind(dialog),
    };
    instance.$el.data('dialog', instance);
    return instance;
}